import PrivateLayout from "./private.layout";

export default PrivateLayout;
